<template>
  <main
    class="mt-0 container"
    id="content-main-page"
    style="background-color: #ffffff"
  >
    <h3 class="fw-bold d-lg-none p-1"></h3>
    <div class="min-vh-100">
      <div class="mb-2 mb-lg-4">
        <template v-if="!authenticated"> </template>
        <template v-else>
          <div class="d-lg-flex justify-content-between mb-3">
            <div></div>

            <div v-if="authenticated">
              <button
                class="btn bg-blue-600 text-white me-2 mb-1"
                data-bs-toggle="modal"
                data-bs-target="#addData"
              >
                <img
                  src="@/assets/img/calendario.png"
                  width="24"
                  class="mr-2"
                />
                Cadastrar nova data
              </button>
              <button class="btn btn-danger mb-1" @click="exportPdf('pt')">
                <img
                  v-if="!loadingExport"
                  src="@/assets/img/pdf.png"
                  alt="Export PDF"
                  width="24"
                  class="mr-2"
                />
                <svg
                  v-else
                  class="mr-3 -ml-1 w-4 h-4 animate-spin text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Exportar para PDF
              </button>
            </div>
          </div>
        </template>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4 mb-md-0">
        <div>
          <div class="flex items-center gap-2 mb-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M12.0846 3.33398H7.91797L5.83464 5.83398H3.33464C2.89261 5.83398 2.46868 6.00958 2.15612 6.32214C1.84356 6.6347 1.66797 7.05862 1.66797 7.50065V15.0007C1.66797 15.4427 1.84356 15.8666 2.15612 16.1792C2.46868 16.4917 2.89261 16.6673 3.33464 16.6673H16.668C17.11 16.6673 17.5339 16.4917 17.8465 16.1792C18.159 15.8666 18.3346 15.4427 18.3346 15.0007V7.50065C18.3346 7.05862 18.159 6.6347 17.8465 6.32214C17.5339 6.00958 17.11 5.83398 16.668 5.83398H14.168L12.0846 3.33398Z"
                stroke="#b98f47"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10 13.334C11.3807 13.334 12.5 12.2147 12.5 10.834C12.5 9.45327 11.3807 8.33398 10 8.33398C8.61929 8.33398 7.5 9.45327 7.5 10.834C7.5 12.2147 8.61929 13.334 10 13.334Z"
                stroke="#b98f47"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="text-lg"
              >Galeria de Fotos - {{ $route.params.data.split("-")[2] }}/{{
                new Date(
                  $route.params.data.split("-")[0],
                  $route.params.data.split("-")[1] - 1,
                  $route.params.data.split("-")[2]
                )
                  .toLocaleString("default", {
                    month: "long",
                  })
                  .toUpperCase()
                  .substring(0, 3)
              }}/{{ $route.params.data.split("-")[0] }}</span
            >
          </div>
          <div v-if="!authenticated" class="relative h-fit">
            <div
              v-if="construction.photos_construction.length == 0"
              class="flex items-center justify-center text-white"
            >
              Sem fotos
            </div>

            <template v-else>
              <div class="relative z-20">
                <swiper
                  :pagination="{
                    clickable: true,
                  }"
                  :navigation="true"
                  class="mySwiper flex items-center"
                  :slides-per-view="1"
                  :space-between="10"
                  style="
                    --swiper-navigation-color: #fff;
                    --swiper-pagination-color: #fff;
                  "
                >
                  >
                  <swiper-slide
                    v-for="(p, index) in construction.photos_construction"
                    :key="index"
                    class="cursor-zoom-in"
                    @click="openGaleryComuns(p)"
                  >
                    <div
                      v-if="isYouTubeUrl(p.src)"
                      class="relative h-full flex items-center"
                    >
                      <iframe
                        class="aspect-video w-full img-banner-img"
                        :src="generateYouTubeIframeUrl(p.src)"
                        frameborder="0"
                        style="aspect-ratio: 16 / 9"
                      ></iframe>
                    </div>
                    <img
                      v-else
                      :src="`${env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${p.src}`"
                      class="h-full w-full object-contain object-center img-banner-img"
                    />

                    <span
                      class="absolute top-2 right-2 lg:top-4 lg:right-4 cursor-zoom-in z-20"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="37"
                        height="37"
                        viewBox="0 0 37 37"
                        fill="none"
                      >
                        <path
                          d="M14.2618 20.9988C12.6201 20.9988 11.2521 19.6308 11.2521 17.9891V17.0999H10.8417C10.0209 17.0999 9.26847 16.7579 8.72125 16.2107C8.17404 15.6634 7.83203 14.911 7.83203 14.0902C7.83203 12.4486 9.20006 11.0805 10.8417 11.0805H11.2521V10.1913C11.2521 9.37051 11.5941 8.61811 12.1413 8.0709C12.6885 7.52368 13.441 7.18164 14.2618 7.18164C15.9034 7.18164 17.2715 8.54969 17.2715 10.1913V11.2174H17.6819C18.5027 11.2174 19.2551 11.5594 19.8023 12.1066C20.3495 12.6538 20.6915 13.4062 20.6915 14.227C20.6915 15.8687 19.3235 17.2367 17.6819 17.2367H17.2715V18.0575C17.2715 18.8783 16.9294 19.6307 16.3822 20.1779C15.835 20.7252 15.0826 20.9988 14.2618 20.9988ZM10.7733 12.9274C10.0893 12.9274 9.47367 13.4746 9.47367 14.227C9.47367 14.9795 9.61047 14.911 9.81567 15.1163C10.0893 15.3899 10.3629 15.5266 10.7049 15.5266H12.0045C12.4833 15.5266 12.8937 15.937 12.8937 16.4159V18.0575C12.8937 18.7415 13.441 19.3572 14.1934 19.3572C14.9458 19.3572 14.8774 19.2203 15.0826 18.9467C15.3562 18.6731 15.4246 18.3995 15.4246 18.0575V16.3475C15.4246 15.8687 15.835 15.4583 16.3138 15.4583H17.6135C18.2975 15.4583 18.9131 14.911 18.9131 14.1586C18.9131 13.4062 18.7763 13.4746 18.5711 13.2694C18.2975 12.9958 18.0239 12.9274 17.6819 12.9274H16.3822C15.9034 12.9274 15.493 12.517 15.493 12.0382V10.3281C15.493 9.64412 14.9458 9.02849 14.1934 9.02849C13.441 9.02849 13.5094 9.1653 13.3042 9.3705C13.0306 9.64411 12.9622 9.91771 12.9622 10.2597V11.9698C12.9622 12.4486 12.5517 12.859 12.0729 12.859H10.7733V12.9274Z"
                          fill="white"
                        />
                        <path
                          d="M31.9769 36.7317H31.7033C30.3352 36.7317 29.104 36.0477 28.2832 34.9533L20.8274 25.9243C20.5538 25.5822 20.5538 25.035 20.9642 24.693C21.3746 24.351 21.8534 24.4194 22.1954 24.8298L29.6512 33.9273C30.1984 34.6113 31.0192 35.0217 31.8401 35.0217C32.7293 35.0901 33.5501 34.7481 34.1657 34.1325C34.7129 33.5852 35.0549 32.7644 35.0549 31.9436C35.0549 31.1228 34.6445 30.2336 33.9605 29.618L24.9315 22.0254C24.5895 21.7517 24.5211 21.2045 24.8631 20.7941C25.2051 20.3837 25.6839 20.3837 26.0943 20.7941L35.0549 28.4551C36.081 29.3443 36.6966 30.644 36.6966 32.0804C36.6966 33.5168 36.2178 34.5429 35.3285 35.4321C34.4393 36.3213 33.2081 36.8001 31.9769 36.8001V36.7317Z"
                          fill="white"
                        />
                        <path
                          d="M14.2617 28.3183C10.4312 28.3183 6.87436 26.8135 4.2067 24.1458C-1.40223 18.6053 -1.40223 9.64465 4.2067 4.17252C6.87436 1.50486 10.4996 0 14.2617 0C18.0238 0 21.6491 1.50486 24.3168 4.17252C26.6424 6.49818 28.1473 9.50785 28.4893 12.7227C28.8313 15.9376 28.0105 19.1525 26.3004 21.8201C25.7532 22.641 25.1376 23.4618 24.4536 24.1458C23.7012 24.8982 22.9487 25.5138 22.0595 26.061C19.7339 27.5659 17.0662 28.3183 14.3301 28.3183H14.2617ZM14.2617 1.77847C10.9101 1.77847 7.76358 3.07809 5.36952 5.40374C0.444608 10.2603 0.444608 18.1265 5.36952 22.983C7.69518 25.3086 10.9101 26.6082 14.1933 26.6082C16.5874 26.6082 18.9814 25.9242 20.9651 24.6246C21.7175 24.1458 22.4015 23.5986 23.0856 22.9145C23.7012 22.2989 24.2484 21.6149 24.7272 20.8625C27.8737 16.006 27.1896 9.43946 23.0856 5.33536C20.8283 3.0097 17.6134 1.77847 14.2617 1.77847Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="observacoes mt-4 hidden lg:block" v-if="!authenticated">
                <h6
                  class="text-sm font-light"
                >
                  OBSERVAÇÕES:
                </h6>
                <p v-if="!authenticated" class="p-4 bg-gray rounded-xl shadow-sm text-sm">
                  {{ construction.observations }}
                </p>
                <textarea
                  v-else-if="authenticated"
                  class="rounded-xl p-4 shadow-sm bg-gray"
                  @keyup="updateConstructionNotReloadDebounced"
                  v-model="construction.observations"
                ></textarea>
              </div>
            </template>
          </div>
          <div
            v-else
            class="d-flex justify-content-center position-relative img-banner"
          >
            <template v-if="construction?.phases">
              <template v-if="authenticated">
                <div class="w-full">
                  <div
                    class="relative z-30 w-full p-1 rounded-xl shadow-sm mb-4"
                    style="background-color: #5C452B"
                  >
                    <div
                      class="border-2 border-white border-dashed p-4 pt-3 pb-3 flex flex-col gap-2 mb-2 rounded-xl"
                    >
                      <draggable
                        v-model="construction.photos_construction"
                        class="flex flex-wrap gap-2 cursor-move"
                        @start="drag = true"
                        @end="drag = false"
                        item-key="url"
                      >
                        <template #item="{ element, index }">
                          <div
                            class="relative drag-item"
                            :data-url="`${env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${element.src}`"
                          >
                            <div
                              v-if="isYouTubeUrl(element.src)"
                              class="relative"
                            >
                              <iframe
                                class="w-28 h-28 object-cover rounded-2xl border border-white"
                                :src="generateYouTubeIframeUrl(element.src)"
                                frameborder="0"
                              ></iframe>
                              <div
                                class="absolute top-0 left-0 h-full w-full z-10"
                              ></div>
                            </div>
                            <img
                              v-else
                              :src="`${env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${element.src}`"
                              class="w-28 h-28 object-cover rounded-2xl border border-white"
                            />
                            <span
                              role="button"
                              @click="
                                loading === index ? null : deletePhoto(index)
                              "
                              class="absolute top-2 right-2 block z-20"
                            >
                              <span v-if="loading === index">
                                <svg
                                  class="animate-spin h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"
                                  ></circle>
                                  <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              </span>
                              <span
                                v-else
                                class="text-red-500 p-2 rounded-full bg-white flex justify-center items-center"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="12"
                                  fill="currentColor"
                                  class="bi bi-trash3"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"
                                  />
                                </svg>
                              </span>
                            </span>
                            <span
                              @click="openPhotoModal(element)"
                              data-bs-toggle="modal"
                              data-bs-target="#photoShow"
                              class="cursor-pointer absolute top-2 right-10 text-blue-500 p-2 rounded-full bg-white flex justify-center items-center z-20"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                fill="currentColor"
                                class="bi bi-eye"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                                />
                                <path
                                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                                />
                              </svg>
                            </span>
                          </div>
                        </template>
                      </draggable>

                      <div class="flex flex-col sm:flex-row gap-2">
                        <button
                          class="btn bg-blue-600 text-white mt-2"
                          @click="
                            !loadingUpload
                              ? $refs.photosConstructionNew.click()
                              : null
                          "
                        >
                          <span v-if="!loadingUpload"> Adicionar imagem</span>
                          <span v-else>
                            <svg
                              class="animate-spin h-5 w-5 text-blue-700"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                          </span>
                          <input
                            name="photos_construction_new"
                            type="file"
                            id="photosConstructionNew"
                            accept="image/*"
                            class="hidden"
                            ref="photosConstructionNew"
                            @change="uploadNewPhotos"
                            multiple
                          />
                        </button>
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#addVideo"
                          class="btn bg-green-600 text-white mt-2"
                        >
                          Adicionar vídeo
                        </button>
                      </div>
                    </div>
                    <p class="text-white text-xs">
                      <ul>
                        <li>
                          Dimensões máximas permitidas (1920x1080)
                        </li>
                        <li> Tamanho máximo por imagem (10MB) </li>
                      </ul>
                    </p>
                  </div>
                  <div class="observacoes mt-4">
                    <h6
                      class="text-sm font-light"
                    >
                      OBSERVAÇÕES:
                    </h6>
                    <p v-if="!authenticated">
                      {{ construction.observations }}
                    </p>
                    <textarea
                      v-else-if="authenticated"
                      class="bg-gray rounded-xl border-0 p-4 shadow-sm"
                      @keyup="updateConstructionNotReloadDebounced"
                      v-model="construction.observations"
                    ></textarea>
                  </div>
                </div>
              </template>
            </template>
            <div v-else>
              <div class="spinner"></div>
            </div>
          </div>
        </div>
        <div v-if="construction?.phases" class="space-y-6">
          <div class="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M18.3346 5.83398L11.2513 12.9173L7.08464 8.75065L1.66797 14.1673"
                stroke="#b98f47"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.332 5.83398H18.332V10.834"
                stroke="#b98f47"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="text-lg"
              >Dashboard de Andamento -
              {{ $route.params.data.split("-")[2] }}/{{
                new Date(
                  $route.params.data.split("-")[0],
                  $route.params.data.split("-")[1] - 1,
                  $route.params.data.split("-")[2]
                )
                  .toLocaleString("default", {
                    month: "long",
                  })
                  .toUpperCase()
                  .substring(0, 3)
              }}/{{ $route.params.data.split("-")[0] }}</span
            >
          </div>

          <!-- Grid de Etapas -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 lg:gap-4">
            <div
              v-for="(phase, index) in construction.phases.filter(
                (item) => !item?.is_total
              )"
              :key="index"
              class="bg-gray rounded-xl p-4 flex flex-col space-y-4"
            >
              <!-- Nome da Etapa -->
              <span class="font-light text-lg truncate" :title="phase.etapa">
                {{ phase.etapa }}
              </span>

              <!-- Previsto -->
              <!-- <div class="space-y-1">
                <div class="flex justify-between items-center">
                  <span class="text-base font-medium text-gray-600"
                    >Previsto</span
                  >
                  <div class="flex items-center space-x-1">
                    <input
                      v-if="authenticated"
                      type="number"
                      class="w-12 text-center rounded-md text-xs"
                      :class="
                        authenticated ? 'border' : 'border-0 bg-transparent'
                      "
                      @keyup="keyUpCamp(phase.previsto, $event)"
                      v-model="phase.previsto"
                      :disabled="!authenticated"
                      style="color: #6b7280"
                    />
                    <span v-else class="text-sm" style="color: #6b7280">{{
                      phase.previsto
                    }}</span>
                    <span class="text-sm font-semibold" style="color: #6b7280"
                      >%</span
                    >
                  </div>
                </div>
                <div
                  class="w-full rounded-full h-2 overflow-hidden"
                  style="background: #e6e6e6;"
                >
                  <div
                    class="h-2 rounded-full"
                    :style="{
                      backgroundColor: '#5c452b',
                      width:
                        phase.previsto >= 0 && phase.previsto <= 100
                          ? phase.previsto + '%'
                          : '0%',
                    }"
                  ></div>
                </div>
              </div> -->

              <!-- Realizado -->
              <div class="space-y-1">
                <div class="flex justify-between items-center">
                  <span class="text-base font-medium text-gray-600"
                    >Realizado</span
                  >
                  <div class="flex items-center space-x-1">
                    <input
                      v-if="authenticated"
                      type="number"
                      class="w-12 text-center rounded-md text-xs"
                      :class="
                        authenticated ? 'border' : 'border-0 bg-transparent'
                      "
                      @keyup="keyUpCamp(phase.realizado, $event)"
                      v-model="phase.realizado"
                      :disabled="!authenticated"
                      style="color: #6b7280"
                    />
                    <span v-else class="text-sm" style="color: #6b7280">{{
                      phase.realizado
                    }}</span>
                    <span class="text-sm font-semibold" style="color: #6b7280"
                      >%</span
                    >
                  </div>
                </div>
                <div
                  class="w-full rounded-full h-2 overflow-hidden"
                  style="background: #e6e6e6;"
                >
                  <div
                    class="h-2 rounded-full"
                    :style="{
                      backgroundColor: '#b98f47',
                      width:
                        phase.realizado >= 0 && phase.realizado <= 100
                          ? phase.realizado + '%'
                          : '0%',
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div class="observacoes mt-4 lg:hidden" v-if="!authenticated">
                <h6
                  class="text-sm font-light"
                >
                  OBSERVAÇÕES:
                </h6>
                <p v-if="!authenticated" class="p-4 bg-gray rounded-xl shadow-sm text-sm">
                  {{ construction.observations }}
                </p>
                <textarea
                  v-else-if="authenticated"
                  class="rounded-xl p-4 shadow-sm bg-gray"
                  @keyup="updateConstructionNotReloadDebounced"
                  v-model="construction.observations"
                ></textarea>
              </div>
        </div>
      </div>
      
    </div>
    <div class="modal" tabindex="-1" id="addEtapa" v-if="authenticated">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nova Etapa</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="construction" class="form-label">Etapa:</label>
              <input type="text" class="form-control" id="nameEtapa" />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="novaEtapa">
              Cadastrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal" tabindex="-1" id="addData" v-if="authenticated">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Nova Atualização de Obra</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="construction" class="form-label">Data:</label>
              <input
                type="date"
                :value="setInputDate()"
                class="form-control"
                id="novaObraData"
              />
            </div>
            <small class="text-warning" id="retornoNovaObra"></small>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="novaObra">
              Cadastrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      tabindex="-1"
      id="photoShow"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Visualização de Mídia</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="
                photoView = '';
                photoDescription = '';
              "
            ></button>
          </div>
          <div class="modal-body">
            <template v-if="photoView">
              <div v-if="isYouTubeUrl(photoView)" class="relative">
                <iframe
                  class="aspect-video w-full"
                  :src="generateYouTubeIframeUrl(photoView)"
                  frameborder="0"
                  style="aspect-ratio: 16 / 9"
                ></iframe>
              </div>
              <img v-else :src="photoView" class="img-fluid" />

              <div class="mt-3">
                <label for="photoDescription" class="form-label"
                  >Descrição:</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="photoDescription"
                  v-model="photoDescription"
                  @input="handleDescriptionInput"
                  placeholder="Adicione uma descrição"
                />
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="addVideo">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Adicionar vídeo</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="videoLink" class="form-label">Link do YouTube:</label>
              <input type="text" v-model="videoAdd" class="form-control" />
            </div>
            <small class="text-warning" id="retornoVideoAdd">{{
              responseMessage
            }}</small>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="addVideoSend">
              Cadastrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="dynamic-gallery-comuns"></div>
  </main>
</template>
<script>
import Cookies from "js-cookie";
import { mapGetters, mapActions } from "vuex";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import { debounce } from "@/helpers/debounce.js";
import SwiperCore, { Navigation, Pagination, Scrollbar } from "swiper/core";
import draggable from "vuedraggable";
SwiperCore.use([Navigation, Pagination, Scrollbar]);

export default {
  name: "DataFilter",
  components: {
    Swiper,
    SwiperSlide,
    draggable,
  },
  data() {
    return {
      construction: {
        photos_construction: [],
      },
      env: process.env,
      loading: null,
      loadingUpload: false,
      photoView: null,
      photoDescription: "",
      drag: false,
      videoAdd: "",
      responseMessage: "",
      photoSelected: null,
      photoSelectedShow: null,
      isLastDate: false,
      isFirstDate: false,
      totalPercent: 0,
      swiperThumbs: null,
      galeryInstance: null,
      loadingExport: false,
      handleConstructionDebounced: null,
      updateConstructionDebounced: null,
      updateConstructionNotReloadDebounced: null
    };
  },
  created() {
    // Criar a versão com debounce da função de salvamento
    this.debouncedSaveDescription = debounce(function () {
      this.savePhotoDescription();
    }, 200);

    this.handleConstructionDebounced = debounce(this.handleConstruction, 500);
    this.updateConstructionDebounced = debounce(this.updateConstruction, 500);
    this.updateConstructionNotReloadDebounced = debounce(
      this.updateConstructionNotReload,
      500
    );
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.params && this.$route.params.data) {
          var data = this.$route.params.data.split("-");
          document.title = `Andamento da Obra - ${data[2]}/${data[1]}/${data[0]}`;
          this.setDate(this.$route.params.data);
        }
      },
    },
    construction: {
      handler(newValue, oldValue) {
        this.handleConstructionDebounced(newValue, oldValue);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["datas", "dataTitles", "authenticated"]),
  },
  methods: {
    ...mapActions(["fetchData"]),
    async handleConstruction(newValue, oldValue) {
      if (newValue) {
        this.isLastDate = newValue.is_last_date;
        this.isFirstDate = newValue.is_first_date;

        const etapas = newValue.phases.filter((phase) => !phase.is_total);
        let totalRealizado = etapas.reduce(
          (acc, etapa) => acc + etapa.realizado,
          0
        );
        let percentualObra = totalRealizado / etapas.length;
        this.totalPercent = percentualObra.toFixed(2);
      }

      if (this.photoSelected == null) {
        this.photoSelected = newValue.photos_construction[0] ?? null;
      }

      if (oldValue.photos_construction.length) {
        var token = Cookies.get("_mysapp_token");
        const url = `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
          "{id_enterprise}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace("{id}", this.construction.id)}/update-order`;

        const paylod = {
          photos_construction: newValue.photos_construction,
        };

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(paylod),
          });
          await response.json();
        } catch (err) {
          console.error("Error uploading file:", err);
        }
      }

      this.$nextTick(() => {
        this.setupGaleryInstance();

        var tooltipTriggerList = [].slice.call(
          document.querySelectorAll('[data-bs-toggle="tooltip"]')
        );
        tooltipTriggerList.map((el) => new bootstrap.Tooltip(el));

        this.setupBackgroundSize();
      });
    },

    onSwiper(swiper) {
      this.swiperThumbs = swiper;
    },

    verificarOrientacao(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
          if (img.width >= img.height) {
            resolve("horizontal");
          } else {
            resolve("vertical");
          }
        };

        img.onerror = () => reject("Erro ao carregar a imagem");
      });
    },

    openPhotoModal(photo) {
      this.photoView = this.isYouTubeUrl(photo.src)
        ? photo.src
        : `${this.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${photo.src}`;
      this.photoDescription =
        (this.construction.photos_construction ?? []).find(
          (item) => item.src == photo.src
        )?.label ?? "";
      this.photoSelectedShow = photo;
    },

    handleDescriptionInput() {
      this.debouncedSaveDescription();
    },

    async savePhotoDescription() {
      if (!this.authenticated) return;

      try {
        let newphotoContruction = {
          src: this.photoSelectedShow.src,
          label: this.photoDescription,
        };

        let indexEdited = this.construction.photos_construction.findIndex(
          (item) => item.src === newphotoContruction.src
        );

        if (indexEdited !== -1) {
          this.construction.photos_construction[indexEdited] =
            newphotoContruction;
        }

        setTimeout(async () => {
          var token = Cookies.get("_mysapp_token");
          const url = `${
            process.env.VUE_APP_ENV_API
          }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
            "{id_enterprise}",
            process.env.VUE_APP_ENV_EMPREENDIMENTOID
          ).replace("{id}", this.construction.id)}/update-descriptions`;

          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              photos_construction: this.construction.photos_construction,
            }),
          });

          const data = await response.json();

          if (data.update !== "ok") {
            console.error("Erro ao salvar descrição");
          }
        }, 500);
      } catch (error) {
        console.error("Erro ao salvar descrição:", error);
      }
    },

    setPhotoSelected(photo) {
      this.photoSelected = photo;

      this.$nextTick(() => {
        this.setupBackgroundSize();
      });
    },
    setInputDate() {
      var hoy = new Date();
      var d = hoy.getDate();
      var m = hoy.getMonth() + 1;
      var y = hoy.getFullYear();

      if (d < 10) d = "0" + d;

      if (m < 10) m = "0" + m;

      var data = y + "-" + m + "-" + d;
      return data;
    },

    calcularTotalPercent(data) {
      const totalItem = data.find((item) => item.is_total);

      if (!totalItem) {
        console.error("Item total com 'is_total: true' não encontrado.");
        return 0;
      }

      const totalEtapas = data.filter((item) => !item.is_total).length;

      const somaRealizado = data
        .filter((item) => !item.is_total)
        .reduce((sum, item) => sum + item.realizado, 0);

      const percentualTotal = somaRealizado / totalEtapas;

      return percentualTotal.toFixed(2);
    },

    async setDate(data) {
      await fetch(
        `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA.replace(
          "{id}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace("{date}", data)}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.enterprise == "not found" || data.enterprise == null) {
            this.$router.push("/");
          } else {
            this.construction = data.enterprise;

            if (this.construction.phases) {
              let indexTotal = this.construction.phases.findIndex(
                (item) => item?.is_total
              );

              if (indexTotal !== -1) {
                let calculated = this.calcularTotalPercent(
                  this.construction.phases
                );
                this.construction.phases[indexTotal].percent =
                  this.construction.phases[indexTotal].percent != calculated &&
                  this.construction.phases[indexTotal].percent != 0 &&
                  this.construction.phases[indexTotal].percent
                    ? this.construction.phases[indexTotal].percent
                    : calculated;
              }
            }

            if (this.construction.photos_construction.length) {
              this.setPhotoSelected(this.construction.photos_construction[0]);
            }
          }
        })
        .catch((err) => console.error(err));
    },
    novaEtapa() {
      const etapa = document.getElementById("nameEtapa");

      if (etapa.value != "" && this.authenticated) {
        const newEtapa = {
          etapa: etapa.value,
          previsto: "0.0",
          realizado: "0.0",
          ocultar: "0",
        };
        this.construction.phases.push(newEtapa);
        this.updateConstructionDebounced();
        this.closeModal("addEtapa");
      }
    },
    removeEtapa(index) {
      if (this.authenticated) {
        if (
          confirm(
            `Você está tem certeza que deseja remover a etapa: '${this.construction.phases[index].etapa}'?`
          )
        ) {
          this.construction.phases.splice(index, 1);
          this.updateConstructionDebounced();
        }
      }
    },
    novaObra() {
      const date = document.getElementById("novaObraData").value;

      const verif = this.datas.enterprise.constructionscolumn.findIndex(
        (c) => c.date === date
      );

      if (verif == -1) {
        var token = Cookies.get("_mysapp_token");

        fetch(
          `${
            process.env.VUE_APP_ENV_API
          }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_CREATE.replace(
            "{id}",
            process.env.VUE_APP_ENV_EMPREENDIMENTOID
          ).replace("{date}", date)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.created == "ok") {
              this.closeModal("addData");
              this.fetchData();
              this.$router.push(`/${date}`);
            } else {
              alert(
                "Não foi possível adicionar uma nova data. Tente novamente mais tarde."
              );
              document.location.reload();
            }
          })
          .catch((err) => console.error(err));
      } else {
        const retorno = document.getElementById("retornoNovaObra");
        retorno.innerText = "Esta data já foi cadastrada!";
        setTimeout(() => {
          retorno.innerText = "";
        }, 2500);
      }
    },
    keyUpCamp(p, event) {
      if (event.target.value < 0 || event.target.value > 100) {
        p = 0;
        event.target.value = 0;
      } else {
        this.updateConstructionNotReloadDebounced();
      }
    },

    closeModal(modl) {
      const modal = document.getElementById(modl);
      modal.classList.remove("show");
      modal.style.display = "none";
      document.querySelector(".modal-backdrop").remove();

      const body = document.querySelector("body");
      body.classList.remove("modal-open");
      body.style.overflow = "auto";
    },
    banner() {
      return `${process.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${this.construction.photos_construction[0]}`;
    },

    tiggerArquivo() {
      const input = document.getElementById("photosConstruction");
      input.click();
    },
    async exportPdf(lang) {
      let firstImage = this.construction.photos_construction[0];
      if (!firstImage) {
        alert("Não há imagens cadastradas.");
        return;
      }

      this.loadingExport = true;

      const orientation = await this.verificarOrientacao(
        `${this.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${firstImage.src}`
      );

      let orientationToExport =
        orientation === "horizontal" ? "vertical" : "horizontal";

      var token = Cookies.get("_mysapp_token");
      fetch(
        `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_APIEXPORT.replace(
          "{id_enterprise}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace(
          "{id}",
          this.construction.id
        )}?lang=${lang}&orientation=${orientationToExport}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((res) => {
          return res.blob();
        })
        .then((data) => {
          var a = document.createElement("a");
          a.href = window.URL.createObjectURL(data);
          a.download = `${this.datas.enterprise.name} - Andamento da Obra - ${this.construction.date}`;
          a.click();
        })
        .finally(() => {
          this.loadingExport = false;
        });
    },
    handleDragStart(event, photoUrl) {
      event.dataTransfer.setData("text/plain", photoUrl);
      this.isDragging = true;
      event.target.classList.add("dragging");
    },
    handleDrop(event, index) {
      event.preventDefault();
      this.isDragging = false;
      const photoUrl = event.dataTransfer.getData("text/plain");
      event.target.classList.remove("dragging");

      // Lógica para atualizar a posição ou estado da imagem solta
      console.log("Dropped photo URL:", photoUrl);
      console.log("Dropped on index:", index);
    },

    previousDate() {
      window.dispatchEvent(new Event("date-prev"));
    },
    nextDate() {
      window.dispatchEvent(new Event("date-next"));
    },

    isYouTubeUrl(url) {
      try {
        const parsedUrl = new URL(url);
        const hostname = parsedUrl.hostname;

        // Verifica se o hostname é do YouTube
        if (
          hostname === "www.youtube.com" ||
          hostname === "youtube.com" ||
          hostname === "youtu.be"
        ) {
          // Verifica se o caminho ou os parâmetros indicam um vídeo
          if (
            parsedUrl.pathname === "/watch" &&
            parsedUrl.searchParams.has("v")
          ) {
            return true; // URL do YouTube no formato "https://www.youtube.com/watch?v=VIDEO_ID"
          } else if (
            parsedUrl.hostname === "youtu.be" &&
            parsedUrl.pathname.length === 12
          ) {
            return true; // URL encurtada "https://youtu.be/VIDEO_ID"
          } else if (parsedUrl.pathname.startsWith("/embed/")) {
            return true; // URL embutida "https://www.youtube.com/embed/VIDEO_ID"
          }
        }
        return false;
      } catch (e) {
        return false; // Retorna falso se a URL não for válida
      }
    },

    generateYouTubeIframeUrl(url) {
      const youtubeRegex =
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|.+\?v=)?([^&=\n%]{11})/;
      const match = url.match(youtubeRegex);

      if (match && match[5]) {
        const videoId = match[5];
        return `https://www.youtube.com/embed/${videoId}`;
      }

      return null;
    },

    addVideoSend() {
      if (!this.videoAdd) {
        this.responseMessage = "Por favor, insira um link de vídeo.";
        return;
      } else if (!this.isYouTubeUrl(this.videoAdd)) {
        this.responseMessage = "Por favor, insira um link de vídeo válido.";
        return;
      }

      var token = Cookies.get("_mysapp_token");

      const sendVideo = async () => {
        const url = `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
          "{id_enterprise}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace("{id}", this.construction.id)}/add-video`;

        const payload = {
          video_link: this.videoAdd,
        };

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          });

          const data = await response.json();

          if (data.update) {
            this.responseMessage = "";
            this.videoAdd = "";
            this.construction.photos_construction =
              data.construction.photos_construction;
            this.closeModal("addVideo");
          } else {
            this.responseMessage = "Erro ao adicionar o vídeo.";
          }
        } catch (error) {
          console.error("Erro ao enviar vídeo:", error);
          this.responseMessage = "Ocorreu um erro ao tentar adicionar o vídeo.";
        }
      };

      sendVideo();
    },
    updateImgConstruction(e) {
      const formData = new FormData(e.target.parentNode);

      var token = Cookies.get("_mysapp_token");
      this.loadingUpload = true;

      fetch(
        `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
          "{id_enterprise}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace("{id}", this.construction.id)}`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          e.target.value = null;
          this.loadingUpload = false;
          if (data.update == "ok") {
            this.construction.photos_construction =
              data.construction.photos_construction;
          } else {
            alert(
              "Não foi possível atualizar os dados. Tente novamente mais tarde."
            );
            document.location.reload();
          }
        })
        .catch((err) => console.error(err));
    },
    validateImage(file) {
      return new Promise((resolve, reject) => {
        // Verificar tamanho do arquivo (máximo 10MB)
        const maxSize = 10 * 1024 * 1024; // 10MB em bytes
        if (file.size > maxSize) {
          reject(
            new Error(
              `O arquivo "${
                file.name
              }" excede o limite de 10MB. Tamanho atual: ${(
                file.size /
                (1024 * 1024)
              ).toFixed(2)}MB`
            )
          );
          return;
        }

        // Verificar se é uma imagem
        if (!file.type.startsWith("image/")) {
          resolve(true); // Não é imagem, mas pode ser válido (como vídeos)
          return;
        }

        // Verificar dimensões da imagem
        const img = new Image();
        img.onload = function () {
          const maxWidth = 1920;
          const maxHeight = 1920;

          if (img.width > maxWidth || img.height > maxHeight) {
            reject(
              new Error(
                `A imagem "${file.name}" excede as dimensões máximas permitidas (1920x1080). Dimensões atuais: ${img.width}x${img.height}`
              )
            );
          } else {
            resolve(true);
          }
        };

        img.onerror = function () {
          // Se não conseguir carregar a imagem, assuma que é válida
          // (pode ser um caso onde o FileReader não consegue ler o arquivo como imagem)
          resolve(true);
        };

        // Carregar a imagem para verificar dimensões
        const reader = new FileReader();
        reader.onload = function (e) {
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    async uploadNewPhotos(event) {
      const files = event.target.files;
      this.loadingUpload = true;

      // Validar cada arquivo antes do upload
      const validFiles = [];
      const invalidFiles = [];

      for (let i = 0; i < files.length; i++) {
        try {
          await this.validateImage(files[i]);
          validFiles.push(files[i]);
        } catch (error) {
          invalidFiles.push({ file: files[i], error: error.message });
        }
      }

      // Mostrar erros se houver arquivos inválidos
      if (invalidFiles.length > 0) {
        const errorMessages = invalidFiles.map((f) => f.error).join("\n");
        alert(`Alguns arquivos foram rejeitados:\n\n${errorMessages}`);
      }

      // Se não há arquivos válidos, interromper o processo
      if (validFiles.length === 0) {
        this.loadingUpload = false;
        event.target.value = null;
        return;
      }

      var token = Cookies.get("_mysapp_token");
      const url = `${
        process.env.VUE_APP_ENV_API
      }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
        "{id_enterprise}",
        process.env.VUE_APP_ENV_EMPREENDIMENTOID
      ).replace("{id}", this.construction.id)}/multiple`;

      const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("photos_construction[]", file);

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              Authorization: "Bearer " + token,
            },
            body: formData,
          });
          return await response.json();
        } catch (err) {
          console.error("Error uploading file:", err);
          return { update: "error" };
        }
      };

      const uploadAllFiles = async () => {
        for (let i = 0; i < validFiles.length; i++) {
          const file = validFiles[i];
          const data = await uploadFile(file);
          if (data.update === "ok") {
            this.construction.photos_construction =
              data.construction.photos_construction;
          } else {
            alert(
              "Não foi possível fazer o upload das novas fotos. Tente novamente mais tarde."
            );
            break;
          }
        }
        this.loadingUpload = false;
        event.target.value = null;
      };

      uploadAllFiles();
    },
    deletePhoto(index) {
      if (confirm("Tem certeza de que deseja excluir esta foto?")) {
        this.loading = index;

        let url = `${
          process.env.VUE_APP_ENV_API
        }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
          "{id_enterprise}",
          process.env.VUE_APP_ENV_EMPREENDIMENTOID
        ).replace("{id}", this.construction.id)}/${index}`;
        url = url.replace("update", "delete");
        fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + Cookies.get("_mysapp_token"),
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === "ok") {
              // Remover a foto da lista localmente
              this.construction.photos_construction.splice(index, 1);
            } else {
              alert(
                "Não foi possível excluir a foto. Tente novamente mais tarde."
              );
            }
          })
          .catch((err) => console.error(err))
          .finally(() => {
            this.loading = null;
          });
      }
    },
    setPorcetagem(padrao, porcentagem) {
      return padrao * (porcentagem / 100);
    },
    updateConstruction() {
      if (this.authenticated) {
        var token = Cookies.get("_mysapp_token");
        fetch(
          `${
            process.env.VUE_APP_ENV_API
          }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
            "{id_enterprise}",
            process.env.VUE_APP_ENV_EMPREENDIMENTOID
          ).replace("{id}", this.construction.id)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify(this.construction),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.update == "ok") {
              this.construction = data.construction;
            } else {
              alert(
                "Não foi possível atualizar os dados. Tente novamente mais tarde."
              );
              document.location.reload();
            }
          })
          .catch((err) => console.error(err));
      }
    },
    updateConstructionNotReload() {
      if (this.authenticated) {
        var token = Cookies.get("_mysapp_token");
        fetch(
          `${
            process.env.VUE_APP_ENV_API
          }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_UPDATE.replace(
            "{id_enterprise}",
            process.env.VUE_APP_ENV_EMPREENDIMENTOID
          ).replace("{id}", this.construction.id)}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify(this.construction),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.update != "ok") {
              alert(
                "Não foi possível atualizar os dados. Tente novamente mais tarde."
              );
              document.location.reload();
            }
          })
          .catch((err) => console.error(err));
      }
    },
    openGaleryComuns(photo) {
      let index = this.construction.photos_construction.findIndex(
        (p) => p.src === photo.src
      );
      if (index !== -1) {
        this.galeryInstance.openGallery(index);
      }
    },

    setupGaleryInstance() {
      if (this.galeryInstance) {
        this.galeryInstance.destroy(true);
        this.galeryInstance = null;
      }

      let images = (this.construction.photos_construction ?? []).map(
        (photo) => {
          return {
            src: `${process.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${photo.src}`,
            thumb: `${process.env.VUE_APP_ENV_APIIMGCONSTRUCTION}/${photo.src}`,
            subHtml: photo.label
              ? `<h5 class="text-2xl 2xl:text-3xl">${
                  photo.label || photo.label != "null" ? photo.label : ""
                }</h5><p></p>`
              : "",
          };
        }
      );

      this.galeryInstance = lightGallery(
        document.getElementById("dynamic-gallery-comuns"),
        {
          dynamic: true,
          plugins: [lgThumbnail, lgZoom],
          dynamicEl: images,
        }
      );
    },

    async setupBackgroundSize() {
      return; // desativado temporariamente
      const div = document.querySelector(".img-obra-full");

      let data = this.getBackgroundPosition(div);

      // loop assíncrono até width e height serem diferentes de 0
      while (!data?.width || !data?.height) {
        await new Promise((resolve) => setTimeout(resolve, 50)); // espera 50ms
        data = this.getBackgroundPosition(div);
      }
    },

    getBackgroundPosition(imgElement) {
      const containerWidth = imgElement.offsetWidth;
      const containerHeight = imgElement.offsetHeight;
      const naturalWidth = imgElement.naturalWidth;
      const naturalHeight = imgElement.naturalHeight;

      // Calcula as proporções
      const containerRatio = containerWidth / containerHeight;
      const imgRatio = naturalWidth / naturalHeight;

      let displayedWidth, displayedHeight, offsetX, offsetY;

      if (imgRatio > containerRatio) {
        // Imagem é mais larga que o container
        displayedWidth = containerWidth;
        displayedHeight = containerWidth / imgRatio;
        offsetX = 0;
        offsetY = (containerHeight - displayedHeight) / 2;
      } else {
        // Imagem é mais alta que o container
        displayedHeight = containerHeight;
        displayedWidth = containerHeight * imgRatio;
        offsetY = 0;
        offsetX = (containerWidth - displayedWidth) / 2;
      }

      document.querySelector("#zoom-image").style.right =
        containerWidth - offsetX - displayedWidth + 15 + "px";
      document.querySelector("#zoom-image").style.top =
        containerHeight - offsetY - displayedHeight + 15 + "px";

      return {
        x: offsetX,
        y: offsetY,
        width: displayedWidth,
        height: displayedHeight,
        right: containerWidth - offsetX - displayedWidth,
        bottom: containerHeight - offsetY - displayedHeight,
      };
    },
  },
  mounted() {},
};
</script>
<style>
.etapas input {
  width: 40px;
  height: 20px;
  background-color: transparent;
  text-align: center;
  color: #5C452B;
}

.observacoes textarea {
  color: #5C452B;
  width: 100%;
  height: 150px;
}

input[type="number"],
.geral-input {
  border: 2px solid white;
  color: #495057;
  outline: none;
  transition: border-color 0.3s ease;
  min-width: 60px;
}

/* Mudança de borda ao focar */
input[type="number"]:focus {
  border-color: #b58857;
}

/* Remove as setas (webkit browsers) */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Remove as setas (Firefox) */
input[type="number"],
.geral-input {
  -moz-appearance: textfield;
}

.legenda {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  display: inline-block;
}

/* .etapa-card:hover .etapa-remove {
        display: block !important;
    } */
.etapa-remove {
  cursor: pointer;
  display: none;
}

.edit-photos {
  position: absolute;
  top: 10px;
  left: 10px;
  display: none;
}

.img-banner:hover .edit-photos {
  display: block;
}

.img-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img-section {
  position: absolute;
  left: 50%;
  top: 50%;
  translate: -50% -50%;
  max-width: 85%;
}

.container-image {
  max-height: 60vh;
  /* background-color: #EBEBEB; */
}

.img-thumb {
  transition: all 0.5s ease-in-out;
}

.img-thumb:hover {
  transform: scale(1.2);
}

#zoom-image {
  transition: all 0.3s ease-in-out;
}

.img-container-full:hover #zoom-image {
  transform: scale(1.2);
}

.img-thumb-active {
  border: 3px solid #276cb1 !important;
}

.geral-input-auth {
  cursor: not-allowed;
}

.card-image {
  height: 500px;
  width: 100%;
  position: relative;
  z-index: 10;
}

.drag-item {
  border: 2px dashed transparent;
}

.drag-item.dragging {
  border-color: #f87000;
}

.thumbs-swiper {
  translate: 0% -15%;
  z-index: 40;
  position: relative;
}

/* .thumbs-swiper .swiper-wrapper {
    display: flex;
    justify-content: center;
} */

.description-image-banner {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  font-size: 1.05rem;
}

.lg-outer .lg-thumb-item.active,
.lg-outer .lg-thumb-item:hover {
  border: 2px solid #276cb1 !important;
}

.swiper-thumber {
  height: 50px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #ddd;
}

.cursor-zoom-in {
  cursor: zoom-in;
}
.bg-gray{
  background-color: #f5f5f5;
}

@media (max-width: 400px) {
  .card-image {
    height: 300px;
    width: 100%;
  }

  .description-image-banner {
    font-size: 0.7rem;
  }
}

@media (max-width: 600px) {
  .swiper-container-div {
    max-width: 85%;
    margin: 0 auto;
  }

  .thumbs-swiper .next {
    right: -10px;
    top: 25%;
  }

  .thumbs-swiper .prev {
    left: -10px;
    top: 25%;
  }

  .thumbs-swiper {
    translate: 0% -8%;
    z-index: 40;
    position: relative;
  }
}

@media (min-width: 401px) and (max-width: 450px) {
  .card-image {
    height: 350px;
    width: 100%;
  }
}

@media (min-width: 451px) and (max-width: 767px) {
  .card-image {
    height: 400px;
    width: 100%;
  }
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr;
  /* padrão até 600px */
  gap: 20px;
}

@media (min-width: 600px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }

  .thumbs-swiper .next {
    right: -60px;
    top: 25%;
  }

  .thumbs-swiper .prev {
    left: -60px;
    top: 25%;
  }
}

@media (min-width: 1200px) {
  .grid-container {
    grid-template-columns: repeat(6, 1fr);
  }

  .container-image {
    max-height: 80vh;
    /* background-color: #EBEBEB; */
  }

  .swiper-thumber {
    height: 90px;
    background-color: #f5f5f5;
    border-radius: 6px;
    border: 1px solid #ddd;
  }
}

@media (min-width: 1024px) {
  .img-banner-img {
    height: 80vh;
    width: 100%;
    object-fit: contain;
    object-position: center;
    background-color: #d9d9d9;
  }
}
</style>
